import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ExtendedAuthService } from '../../../util/auth/auth.service';
import { FrontendSocialsComponent } from '../frontend-socials/frontend-socials.component';
import { RouterModule } from '@angular/router';
import { i18nRouterLinkDirective } from '../../../util/router/i18n-router-link.directive';

@Component({
  selector: 'app-frontend-footer',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    FrontendSocialsComponent,
    RouterModule,
    i18nRouterLinkDirective,
  ],
  templateUrl: './frontend-footer.component.html',
})
export class FrontendFooterComponent {
  constructor(
    public auth: ExtendedAuthService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
  ) {
    iconRegistry.addSvgIcon(
      'twitter',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/twitter.svg'),
    );

    iconRegistry.addSvgIcon(
      'instagram',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/instagram.svg'),
    );

    iconRegistry.addSvgIcon(
      'youtube',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/youtube.svg'),
    );

    iconRegistry.addSvgIcon(
      'tiktok',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/tiktok.svg'),
    );

    iconRegistry.addSvgIcon(
      'linkedin',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/linkedin.svg'),
    );
  }
}
